import { MessagingTier } from '@graphql/generated-base';

// hotel tier has the same access as messagingPlus
export const isMessagingPlusTier = (tier: MessagingTier | null | undefined): boolean => tier === MessagingTier.messagingPlus || tier === MessagingTier.hotel;
